import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { NetflixNav } from './components/NetflixNav';
import { NetflixHero } from './components/NetflixHero';
import { VideoRow } from './components/VideoRow';
import { ExperienceRow } from './components/ExperienceRow';
import { ExpertiseRow } from './components/ExpertiseRow';
import { ProjectsRow } from './components/ProjectsRow';
import { PublicationsRow } from './components/PublicationsRow';
import { AwardsRow } from './components/AwardsRow';
import { EducationRow } from './components/EducationRow';
import { PhotoGallery } from './components/PhotoGallery';
import { ContactSection } from './components/ContactSection';
import { NetflixFooter } from './components/NetflixFooter';
import './App.css';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NetflixPortfolio = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log('Backend connected:', response.data.message);
    } catch (e) {
      console.error('Backend connection error:', e);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="min-h-screen bg-netflix-black text-white">
      <NetflixNav />
      <main>
        <NetflixHero />
        <VideoRow />
        <ExperienceRow />
        <ExpertiseRow />
        <ProjectsRow />
        <PublicationsRow />
        <AwardsRow />
        <EducationRow />
        <PhotoGallery />
        <ContactSection />
      </main>
      <NetflixFooter />
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: {
            background: '#221f1f',
            border: '1px solid #333333',
            color: '#ffffff'
          },
          duration: 4000
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NetflixPortfolio />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;